module.exports = __webpack_public_path__ + "media/images/animations/wide_loads/1-8ce7c90689e5d19469fff15b7aaba2fe.png";